import { render, staticRenderFns } from "./EditViewList.vue?vue&type=template&id=f013ffb4&scoped=true&"
import script from "./EditViewList.vue?vue&type=script&lang=js&"
export * from "./EditViewList.vue?vue&type=script&lang=js&"
import style0 from "./EditViewList.vue?vue&type=style&index=0&id=f013ffb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013ffb4",
  null
  
)

export default component.exports